// extracted by mini-css-extract-plugin
export var dropdown = "_ps-1";
export var hidden = "_ps-0";